import { BRAND } from "@/lib/brand";

const TIMELINE = [
  { tag: "Then", title: "Gang life", body: "Born into cycles he didn't choose — a young man searching for belonging in the streets." },
  { tag: "The Cost", title: "13 years behind bars", body: "A long sentence became a longer reckoning. Joel rebuilt himself in the place that tried to break him." },
  { tag: "Now", title: "A free man walking in purpose", body: "Author, mentor, community outreach liaison — turning his story into a roadmap for other men." },
];

export default function AboutJoel() {
  return (
    <section data-testid="about-section" id="about" className="relative px-6 md:px-12 lg:px-20 py-24 md:py-32 border-t border-[color:var(--border-subtle)]">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
        <div className="lg:col-span-5">
          <div className="relative overflow-hidden border border-[color:var(--border-gold)] bg-[color:var(--navy-950)] flex items-end justify-center">
            <img
              src="/generated/joel_cutout.png"
              alt="Joel M. Alexander"
              className="w-auto h-[560px] md:h-[680px] object-contain object-bottom"
              data-testid="about-joel-photo"
            />
            <div className="absolute bottom-0 left-0 right-0 px-6 py-5 bg-gradient-to-t from-[color:var(--navy-950)]/95 to-transparent">
              <div className="eyebrow">From the streets to purpose</div>
              <div className="font-display font-bold uppercase text-2xl md:text-3xl mt-1 tracking-tight">
                Every step is a choice.
              </div>
            </div>
          </div>
        </div>

        <div className="lg:col-span-7 lg:pl-8">
          <div className="flex items-center gap-3 mb-6">
            <span className="w-10 h-px bg-[color:var(--gold-500)]" />
            <span className="eyebrow">About Joel</span>
          </div>
          <h2 className="font-display font-black uppercase leading-[0.9] tracking-tighter text-5xl md:text-6xl text-white">
            From the streets,<br />
            <span className="text-[color:var(--gold-500)]">into purpose.</span>
          </h2>
          <p className="mt-8 max-w-xl text-lg text-[color:var(--text-secondary)] leading-relaxed">
            Joel built <span className="text-white">The Way Forward</span> for the man no one
            wrote off until he wrote off himself — and for the family, employer, or mentor walking with
            him. Every offering is rooted in lived experience and clinical-grade structure.
          </p>

          <div className="mt-12 space-y-8">
            {TIMELINE.map((t, i) => (
              <div key={t.title} className="grid grid-cols-12 gap-6 items-start group">
                <div className="col-span-3 md:col-span-2">
                  <div className="eyebrow">{t.tag}</div>
                  <div className="mt-2 text-[color:var(--gold-500)] font-display font-bold text-3xl leading-none">
                    0{i + 1}
                  </div>
                </div>
                <div className="col-span-9 md:col-span-10 border-l border-[color:var(--border-subtle)] pl-6 group-hover:border-[color:var(--border-gold)] transition-colors">
                  <h3 className="font-display uppercase text-2xl md:text-3xl tracking-tight">{t.title}</h3>
                  <p className="mt-2 text-[color:var(--text-secondary)] leading-relaxed max-w-xl">{t.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
